import React from 'react'

import Base from '../_Base'

const Brazil14 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_14)">
      <rect width="24" height="24" rx="2" fill="#F58220" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14.07 8.44-1.293 4.88h1.304l.113-4.886h-.125v.006Zm-.897-1.468h2.756v6.349h1.213v1.502h-1.213v2.205h-1.91v-2.205H11.29v-1.718l1.882-6.133ZM8.292 6.972H10v10.056H8.054V9.551a3.2 3.2 0 0 1-.55.454 3.417 3.417 0 0 1-.646.317V8.514c.346-.199.64-.426.884-.686.238-.255.42-.539.55-.856Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_14">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default Brazil14
